import { getError } from "./error";
import { STATUS_LO } from "../consts";
import type { ExemptedCourse } from "../types";

export function isExemptLo (status?: string | null): boolean {
  return status === STATUS_LO.X;
}

export type ExemptedCoursePayload = {
  exemptedLearningObjectId: number;
};

export type ExemptedCourseApiFields = {
  exemptedLearningObjectId?: number | null;
  exemptedLearningObjectTitle?: string | null;
};

export function toExemptedCoursePayload (course?: ExemptedCourse | null): Partial<ExemptedCoursePayload> {
  if (!course) return {};
  return { exemptedLearningObjectId: course.id };
}

export function fromExemptedCourseApiFields (item: ExemptedCourseApiFields): ExemptedCourse | undefined {
  if (item.exemptedLearningObjectId == null) return undefined;
  return {
    id: Number(item.exemptedLearningObjectId),
    title: item.exemptedLearningObjectTitle ?? ""
  };
}

const EXEMPTION_ERROR_MESSAGE_KEYS: Record<string, string> = {
  EXTERNAL_TRAINING_EXEMPTION_NOT_ENROLLED: "exempted_course_error_not_enrolled",
  EXTERNAL_TRAINING_EXEMPTION_NOT_EXEMPTABLE: "exempted_course_error_not_exemptable",
  EXTERNAL_TRAINING_EXEMPTION_REJECTED: "exempted_course_error_rejected"
};

export function getExemptionErrorMessageKey (error: unknown): string | undefined {
  const code = getError(error)?.map((item) => item.cause).find(
    (cause): cause is string => typeof cause === "string" && cause in EXEMPTION_ERROR_MESSAGE_KEYS
  );
  return code ? EXEMPTION_ERROR_MESSAGE_KEYS[code] : undefined;
}
